import {
  cancelFlushSession,
  finalizeFlushSession,
  getActiveFlushSession,
  getFlushSession,
  listFlushMerchants,
  scanFlushItem,
  startFlushSession,
} from "./schema/flush";

export const groupM: {
  cancelFlushSession: typeof cancelFlushSession;
  finalizeFlushSession: typeof finalizeFlushSession;
  getActiveFlushSession: typeof getActiveFlushSession;
  getFlushSession: typeof getFlushSession;
  listFlushMerchants: typeof listFlushMerchants;
  scanFlushItem: typeof scanFlushItem;
  startFlushSession: typeof startFlushSession;
} = {
  cancelFlushSession,
  finalizeFlushSession,
  getActiveFlushSession,
  getFlushSession,
  listFlushMerchants,
  scanFlushItem,
  startFlushSession,
};
